
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'IssueSearch',

  props: {
    searchCandidate: {
      type: String as PropType<string | null>,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Search for issue or file'
    },
    expandOnFocus: {
      type: Boolean,
      default: true
    }
  },

  emits: ['updateSearch'],

  data() {
    return {
      searchFocused: false
    }
  },

  computed: {
    modelValue: {
      get() {
        return this.searchCandidate
      },
      set(value: typeof this.searchCandidate) {
        this.$emit('updateSearch', value)
      }
    }
  }
})
